(function() {
  'use strict';
  
  var delayPatterns = [
    'postscript',
    'clarity.ms',
    'bat.bing.com',
    'loox.io',
    'gotolstoy',
    'retention.com',
    'wetracked.io',
    'notify-me.io',
  ];

  var blockedScripts = [];
  var activated = false;

  // Override createElement to intercept script injection
  var _createElement = document.createElement.bind(document);
  document.createElement = function(tag) {
    var el = _createElement(tag);
    if (tag.toLowerCase() !== 'script') return el;

    // Proxy the src setter
    var _src = '';
    Object.defineProperty(el, 'src', {
      get: function() { return _src; },
      set: function(val) {
        var shouldDelay = !activated && delayPatterns.some(function(p) {
          return String(val).indexOf(p) !== -1;
        });
        if (shouldDelay) {
          _src = val;
          blockedScripts.push(el);
          // Prevent actual load by not setting real src yet
        } else {
          _src = val;
          Object.defineProperty(el, 'src', { value: val, writable: true });
          el.setAttribute('src', val);
        }
      },
      configurable: true
    });
    return el;
  };

  function releaseScripts() {
    if (activated) return;
    activated = true;
    document.createElement = _createElement; // restore original

    blockedScripts.forEach(function(script) {
      var realSrc = script.src;
      // Create a clean script tag and inject it
      var s = _createElement('script');
      s.src = realSrc;
      s.async = true;
      document.head.appendChild(s);
    });
    blockedScripts = [];
  }

  // Trigger on user interaction OR 4 seconds — whichever first
  var timer = setTimeout(releaseScripts, 4000);

  var events = ['mousemove', 'keydown', 'touchstart', 'scroll', 'click'];
  function onInteract() {
    clearTimeout(timer);
    events.forEach(function(e) {
      document.removeEventListener(e, onInteract);
    });
    releaseScripts();
  }

  events.forEach(function(e) {
    document.addEventListener(e, onInteract, { passive: true });
  });

})();